import { useContext, useEffect, useState, type FC } from "react";
import MainLayout from "../components/MainLayout";
import { LoadingContext } from "../contexts/LoadingContext";
// import { getCompanyDetails } from '../services/company/CompanyApi';
import { errorToast } from "../utils/helper-ui";
import {
  createCompany,
  getCompanies,
  updateCompany,
} from "../services/company/CompanyApi";
import { SearchContext } from "../contexts/SearchContext";
import { PaginationResponse } from "../objects/pagination";
import { Button, Checkbox, IconButton, Pagination, Table } from "rsuite";
// import { Company } from '../models/company';
import PlusIcon from "@rsuite/icons/Plus";
import { Company } from "../models/company/company";
import { getPagination, noImage } from "../utils/helper";
import CompanyForm from "../components/features/company/CompanyForm";
const { Column, HeaderCell, Cell } = Table;
interface CompanyPageProps {}

const CompanyPage: FC<CompanyPageProps> = ({}) => {
  const { search, setSearch } = useContext(SearchContext);
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const [mounted, setMounted] = useState(false);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [pagination, setPagination] = useState<PaginationResponse>();
  const [companies, setCompanies] = useState<Company[]>([]);
  const [modalFormOpen, setModalFormOpen] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState<Company>();

  const [checkedKeys, setCheckedKeys] = useState<string[]>([]);
  let checked = false;
  let indeterminate = false;

  if (checkedKeys.length === companies.length) {
    checked = true;
  } else if (checkedKeys.length === 0) {
    checked = false;
  } else if (checkedKeys.length > 0 && checkedKeys.length < companies.length) {
    indeterminate = true;
  }

  const handleCheckAll = (
    value: any,
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keys = checked ? companies.map((item) => item.id) : [];
    setCheckedKeys(keys);
  };
  const handleCheck = (
    value: any,
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keys = checked
      ? [...checkedKeys, value as string]
      : checkedKeys.filter((item) => item !== (value as string));
    setCheckedKeys(keys);
  };

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!mounted) return;

    fetchData();
  }, [mounted, page, size, search]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await getCompanies({ page, size, search });
      const resJson = await res.json();
      // setCompany(data);
      setCompanies((prev) => [...prev, ...resJson.data.items]);
      setPagination(getPagination(resJson.data));
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  const renderHeader = () => (
    <div className="flex flex-row justify-between items-center px-2">
      <h1 className="text-2xl font-semibold">Company</h1>
      {/* button */}
      <div>
        <IconButton
          size="sm"
          appearance="primary"
          color="green"
          icon={<PlusIcon />}
          onClick={() => setModalFormOpen(true)}
        >
          Create Company
        </IconButton>
      </div>
    </div>
  );

  const saveCompany = async (company: Company) => {
    try {
      setIsLoading(true);
      if (selectedCompany) {
        await updateCompany(selectedCompany.id!, company);
      } else {
        await createCompany(company);
      }
      setModalFormOpen(false);
      setSelectedCompany(undefined);
      fetchData();
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <MainLayout header={renderHeader()}>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr>
              <th className="px-4 py-2 text-left border bg-gray-50 w-32">
                <Checkbox
                  inline
                  checked={checked}
                  indeterminate={indeterminate}
                  onChange={handleCheckAll}
                />
              </th>
              <th className="px-4 py-2 text-left border bg-gray-50">Name</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Logo</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Cover</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Email</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Phone</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Address</th>
            </tr>
          </thead>
          <tbody>
            {companies.map((company, i) => (
              <tr key={company.id}>
                <td className="px-4 py-2 border">
                  <Checkbox
                    value={company.id}
                    inline
                    onChange={handleCheck}
                    checked={checkedKeys.some((item) => item === company.id)}
                  />
                  {i + 1}
                </td>
                <td className="px-4 py-2 border">
                  <div
                    className="hover:underline cursor-pointer font-semibold "
                    onClick={() => {
                      setSelectedCompany(company as Company);
                      setModalFormOpen(true);
                    }}
                  >
                    {company.name}
                  </div>
                </td>
                <td className="px-4 py-2 border">
                  <img
                    onError={noImage}
                    src={company.logo}
                    alt={company.name}
                  />
                </td>
                <td className="px-4 py-2 border">
                  <img
                    onError={noImage}
                    src={company.cover}
                    alt={company.name}
                  />
                </td>
                <td className="px-4 py-2 border">{company.email}</td>
                <td className="px-4 py-2 border">{company.phone}</td>
                <td className="px-4 py-2 border">{company.address}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {!pagination?.last && (
        <div className="flex justify-center my-2">
          <Button
            onClick={() => {
              setPage((pagination?.page ?? 0) + 1);
            }}
          >
            Load more
          </Button>
        </div>
      )}
      {/* <Table minHeight={700} data={companies} onRowClick={(data, i) => {}}>
        <Column width={50} align="center" fixed>
          <HeaderCell style={{ padding: 0 }}>
            <div style={{ lineHeight: "40px" }}>
              <Checkbox
                inline
                checked={checked}
                indeterminate={indeterminate}
                onChange={handleCheckAll}
              />
            </div>
          </HeaderCell>
          <Cell style={{ padding: 0 }}>
            {(rowData) => (
              <div style={{ lineHeight: "46px" }}>
                <Checkbox
                  value={rowData.id}
                  inline
                  onChange={handleCheck}
                  checked={checkedKeys.some((item) => item === rowData.id)}
                />
              </div>
            )}
          </Cell>
        </Column>
        <Column width={70} align="center" fixed>
          <HeaderCell>No</HeaderCell>
          <Cell>
            {(rowData) => (
              <div>
                {(page - 1) * size + companies.indexOf(rowData as Company) + 1}
              </div>
            )}
          </Cell>
        </Column>
        <Column width={200} resizable fixed>
          <HeaderCell>Company Name</HeaderCell>
          <Cell>
            {(rowData) => (
              <div
                className="hover:underline cursor-pointer font-semibold "
                onClick={() => {
                  setSelectedCompany(rowData as Company);
                  setModalFormOpen(true);
                }}
              >
                {rowData.name}
              </div>
            )}
          </Cell>
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Logo</HeaderCell>
          <Cell style={{ padding: 0 }}>
            {(rowData) => (
              <div>
                <img
                  onError={noImage}
                  src={rowData.logo}
                  alt="logo"
                  width={50}
                  height={50}
                />
              </div>
            )}
          </Cell>
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Cover</HeaderCell>
          <Cell style={{ padding: 0 }}>
            {(rowData) => (
              <div>
                <img
                  onError={noImage}
                  src={rowData.cover}
                  alt="cover"
                  width={50}
                  height={50}
                />
              </div>
            )}
          </Cell>
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Legal Entity</HeaderCell>
          <Cell dataKey="legal_entity" />
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Email</HeaderCell>
          <Cell dataKey="email" />
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Phone</HeaderCell>
          <Cell dataKey="phone" />
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Fax</HeaderCell>
          <Cell dataKey="fax" />
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Address</HeaderCell>
          <Cell dataKey="address" />
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Contact Person</HeaderCell>
          <Cell dataKey="contact_person" />
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Contact Person Position</HeaderCell>
          <Cell dataKey="contact_person_position" />
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Status</HeaderCell>
          <Cell dataKey="status" />
        </Column>
      </Table> */}
      {/* <div style={{ padding: 20 }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="xs"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={pagination?.total ?? 0}
          limitOptions={[10, 30, 50]}
          limit={pagination?.size}
          activePage={pagination?.page}
          onChangePage={setPage}
          onChangeLimit={setSize}
        />
      </div> */}
      <CompanyForm
        company={selectedCompany}
        open={modalFormOpen}
        onClose={() => {
          setModalFormOpen(false);
          setSelectedCompany(undefined);
        }}
        onSubmit={saveCompany}
      />
    </MainLayout>
  );
};

export default CompanyPage;
